import React, {
  type CSSProperties,
  type HTMLAttributes,
  type ReactNode
} from "react"

interface PositionedRect {
  id: string
  x: number
  y: number
  width: number
  height: number
}

interface FieldLayerProps<T extends PositionedRect>
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  items: T[]
  render: (item: T, style: CSSProperties) => ReactNode
}

const percent = (fraction: number) => `${fraction * 100}%`

export const positionOf = (rect: PositionedRect): CSSProperties => ({
  position: "absolute",
  left: percent(rect.x),
  top: percent(rect.y),
  width: percent(rect.width),
  height: percent(rect.height)
})

/** Positions by percentage, so items follow the page at whatever size it is drawn. */
export function FieldLayer<T extends PositionedRect>({
  items,
  render,
  className,
  ...rest
}: FieldLayerProps<T>) {
  return (
    <div className={`absolute inset-0 ${className ?? ""}`} {...rest}>
      {items.map((item) => (
        <React.Fragment key={item.id}>
          {render(item, positionOf(item))}
        </React.Fragment>
      ))}
    </div>
  )
}

export default FieldLayer
